// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2iLHk","title":"BackImages_title__11_dr","images":"BackImages_images__2t20M"};